import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Navigation } from "retro";
import Active from "./Active";
import InActive from "./InActive";

export default function BINManagement() {
  const HISTORY = useHistory();

  // State for active tab
  const [activeTab, setActiveTab] = useState("activeBINs");

  const tabs = ["Active BINs", "Inactive BINs"];
  const onCreateNew = () => {
    HISTORY.push('/app/demo/bin-management/new');
  }

  const onEditBin = (bin) => {
    HISTORY.push(`/app/demo/bin-management/new/${bin.bin}`);
  }

  return (
    <div>
      <Navigation
        backUrl={""}
        title="All Bins"
        chips={["All Bins"]}
        description="All bins are listed below."
      />

      {/* Tabs */}
      <div style={{ display: "flex", marginTop: "1.5rem", marginBottom: "1rem" }}>
        {tabs.map((tab) => {
          const key = tab
            .split(" ")
            .map((word, index) =>
              index === 0 ? word.toLowerCase() : word[0].toUpperCase() + word.slice(1)
            )
            .join("");

          return (
            <button
              key={key}
              onClick={() => setActiveTab(key)}
              style={{
                padding: "8px 20px",
                marginRight: "8px",
                border: "none",
                borderBottom: activeTab === key ? "3px solid #0f172a" : "3px solid transparent",
                backgroundColor: "transparent",
                fontWeight: activeTab === key ? 600 : 500,
                color: activeTab === key ? "#0f172a" : "#64748b",
                cursor: "pointer",
                transition: "color 0.2s, border-bottom 0.2s",
              }}
            >
              {tab}
            </button>
          );
        })}
      </div>

      {/* Tab content */}
      <div style={{ padding: "1rem", border: "1px solid #e5e7eb", borderRadius: "0.5rem" }}>
        {activeTab === "activeBINs" && <Active onCreateNew={onCreateNew}  onEditBin={onEditBin}/>}
        {activeTab === "inactiveBINs" && <InActive onCreateNew={onCreateNew}  onEditBin={onEditBin}/>}
      </div>
    </div>
  );
}
